import React, { useEffect, useState } from "react";
import Footer from "./footer";
import { useForm } from "react-hook-form";
import useQuery from "../../shared/utils/queryParams";
import ErrorMessage from "../../shared/components/errorMessage";
import styled from "styled-components";
import Layout from "../../shared/components/layout";

const TogglePasswordVisibilityButton = styled.span`
  float: right;
  color: #0170bc;
  font-weight: 600;
  position: relative;
  top: -30px;
  right: 10px;
`;

const RegisterContainer = styled.div`
  text-align: center;
  margin-top: 15px;
  font-weight: 600;
`;

const RegisterSpanish = styled.div`
  margin-top: 15px;
`;

const InputContainer = styled.div`
  margin-bottom: 25px;

  input {
    width: 100%;
    background: #fff;
    border: 1px solid #e4e4e4;
    border-radius: 0.5rem;
    box-shadow: inset 1px 1px 4px 0 rgba(0, 0, 0, 0.2);
    padding: 0.5rem;
  }

  a {
    float: right;
  }
`;

function SignIn() {
  const { register, handleSubmit, errors } = useForm();
  const [errorMessage, setErrorMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const forgotIdUrl = `${process.env.REACT_APP_MY_CIGNA_URL}/forgotid?domain=hi2`;
  const forgotPswdUrl = `${process.env.REACT_APP_MY_CIGNA_URL}/forgotpassword?domain=hi2`;
  const registrationUrl = `${process.env.REACT_APP_MY_CIGNA_URL}/registration?domain=hi2`;
  const registrationUrlSpanish = `${process.env.REACT_APP_MY_CIGNA_URL}/registration?lang=es&domain=hi2`;

  const query = useQuery();

  useEffect(() => {
    checkForErrors();
  });

  const checkForErrors = () => {
    const errorMessages = {
      "login-failed":
        "The username and password combination you entered does not match our records",
      "login-attempts-reached":
        "Sorry, you’ve entered the incorrect password too many times. You can try again in 1 hour.",
      logout:
        "You’ve logged out successfully. Re-enter your username and password to log back in to your account.",
      unavailable:
        "Oops… myCigna is currently unavailable. We are working to correct the issue. Please try again later.",
      "direct-login":
        "Sorry, we’re having trouble logging you in directly to this domain. For your security, we’ve logged you out.",
      "reset-password":
        "You logged in using a temporary password. Please go to myCigna.com to create your permanent password.",
      timeout:
        "For your security, your session has timed out. Re-enter your username and password to log back in to your account.",
    };

    Object.keys(errorMessages).forEach((param) => {
      if (query.get(param) === "true") {
        return setErrorMessage(errorMessages[param]);
      }
    });
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const onSubmit = () => {
    const loginForm = document.getElementById("login-form");
    loginForm.action = process.env.REACT_APP_LOGIN_URL;
    loginForm.submit();
  };

  return (
    <div>
      {errorMessage ? (
        <ErrorMessage message={errorMessage}></ErrorMessage>
      ) : null}

      <Layout header={"Log in to share health information"}>
        <form id="login-form" method="post" onSubmit={handleSubmit(onSubmit)}>
          <input
            type="hidden"
            id="login-form-type"
            name="login-form-type"
            value="pwd"
          ></input>

          <InputContainer>
            <label className="bold" htmlFor="username">
              Username
            </label>
            <a href={forgotIdUrl}>Forgot Username?</a>
            <br />
            <input
              className="basic-input"
              id="username"
              type="text"
              name="username"
              ref={register({ required: true })}
            />
            <span className="validation-error-msg">
              {errors.username && "Please enter a username."}
            </span>
          </InputContainer>

          <InputContainer>
            <label className="bold" htmlFor="password">
              Password
            </label>
            <a href={forgotPswdUrl}>Forgot Password?</a>
            <br />
            <div className="password-container">
              <input
                className="basic-input"
                id="password"
                type={showPassword ? "text" : "password"}
                name="password"
                ref={register({ required: true })}
              />
              <TogglePasswordVisibilityButton
                onClick={togglePasswordVisibility}
              >
                {showPassword ? "Hide" : "Show"}
              </TogglePasswordVisibilityButton>
            </div>
            <span className="validation-error-msg">
              {errors.password && "Please enter a password."}
            </span>
          </InputContainer>

          <button className="btn btn-primary btn-block bold" type="submit">
            Log In
          </button>
        </form>

        <RegisterContainer>
          <div>Haven't created an account yet?</div>
          <br />
          <a
            href={registrationUrl}
            className="btn bold btn-secondary btn-block"
          >
            Register
          </a>

          <RegisterSpanish>
            <a href={registrationUrlSpanish}>Registrarse en Español</a>
          </RegisterSpanish>
        </RegisterContainer>
        <Footer></Footer>
      </Layout>
    </div>
  );
}

export default SignIn;
